import { render, staticRenderFns } from "./LinkColumn.vue?vue&type=template&id=3f9c883c&"
import script from "./LinkColumn.vue?vue&type=script&lang=ts&"
export * from "./LinkColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports